export default {
  previousPage: 'Previous page',
  nextPage: 'Next page',
  of: 'of',
};
